// @flow
import {endpoints} from '../../../endpoints'


export const fetchServiceProvidersByCity = async (apiIndex: ApiIndex<MapApi>, city: ?Url, district: ?Url, page: ?string): Promise<PaginationResponse<PartnerPlace>> => {
  let params = `partner=${endpoints.partner}`
  if (city) {
    params += `&city${city}`
  }
  if (district) {
    params += `&district=${district}`
  }

  if (page) {
    params += `&page=${page}`
  }

  const apiPath = apiIndex.apis['partner']['service-providers']['list']['url']
  const url = `${apiIndex.basePath}${apiPath}?${params}`
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json; version=2.0',
      'Accept': 'application/json; version=2.0',
    },
  })

  if (response.status === 200) {
    return await response.json()
  } else {
    throw new Error(await response.text())
  }
}